import React, { useRef, useState } from 'react';
import styles from './styles.module.css';
import { Icons } from '@/assets';
import { ReactSVG } from 'react-svg';
import { useOutsideAlerter } from '@/hocs';

const FilterSection = ({
  title,
  category,
  options,
  setFilters,
  filters,
  lastItemTitle = 'SSL',
  includeLabel = false,
}) => {
  const handleChange = (category, value, label) => {
    setFilters((prev) => {
      const currentValues = prev[category] || [];
      const isSelected = includeLabel
        ? currentValues.some(
            (item) => (typeof item === 'object' ? item.value : item) === value
          )
        : currentValues.includes(value);

      if (isSelected) {
        // Remove the item
        const newValues = includeLabel
          ? currentValues.filter(
              (item) => (typeof item === 'object' ? item.value : item) !== value
            )
          : currentValues.filter((item) => item !== value);
        return {
          ...prev,
          [category]: newValues,
        };
      } else {
        // Add the item
        const newItem = includeLabel ? { value, label } : value;
        return {
          ...prev,
          [category]: [...currentValues, newItem],
        };
      }
    });
  };

  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);

  useOutsideAlerter(wrapperRef, () => setTimeout(() => setOpen(false), 200));

  return (
    <div className={styles.section} ref={wrapperRef}>
      <div
        className={styles.header}
        style={{
          borderBottom:
            open || title === lastItemTitle ? 'none' : '1px solid #E1E4EA',
        }}
        onClick={() => setOpen(!open)}>
        <span
          className={styles.label}
          style={{
            color: open ? '#335CFF' : '#131517',
          }}>
          {title}
        </span>
        <span className={styles.arrow}>
          {!open ? (
            <ReactSVG
              src={Icons.arrowDownNew}
              beforeInjection={(svg) => {
                svg.setAttribute('width', '16px');
                svg.setAttribute('height', '16px');
              }}
              className={styles.arrowIcon}
            />
          ) : (
            <ReactSVG
              src={Icons.arrowUp}
              className={styles.arrowIcon}
              beforeInjection={(svg) => {
                svg.setAttribute('width', '16px');
                svg.setAttribute('height', '16px');
                svg.querySelectorAll('path').forEach((path) => {
                  path.setAttribute('fill', '#335CFF');
                });
              }}
            />
          )}
        </span>
      </div>

      {open && (
        <div className={styles.options}>
          {options.map((opt) => (
            <label
              key={opt?.value}
              className={`${styles.option} ${
                opt.disabled ? 'opacity-70' : ''
              }`}>
              <input
                type="checkbox"
                checked={
                  includeLabel
                    ? filters[category]?.some(
                        (item) =>
                          (typeof item === 'object' ? item.value : item) ===
                          opt?.value
                      )
                    : filters[category]?.includes(opt?.value)
                }
                className={`${styles.checkBox}`}
                onChange={() => handleChange(category, opt?.value, opt?.label)}
                disabled={opt.disabled}
              />
              {opt?.label}
            </label>
          ))}
        </div>
      )}
    </div>
  );
};

export default FilterSection;
